// Tag configuration
// Tag configuration
export const TAG_CONFIG = {
    MAX_TAGS: parseInt(process.env.REACT_APP_MAX_TAGS || '10', 10),
    MAX_TAG_LENGTH: parseInt(process.env.REACT_APP_MAX_TAG_LENGTH || '20', 10),
    TAG_PATTERN: /^[a-zA-Z0-9 _-]+$/,
    TAG_PATTERN_MESSAGE: 'Special characters not allowed. Use only letters, numbers, spaces, hyphens, and underscores.'
};